<div
  class="flex h-[60vh] w-[66vw] flex-col px-10 pb-[135px] pt-[135px]"
  [hidden]="isShow === false"
>
  <div
    *ngIf="isShow === true"
    class="center flex h-full w-full flex-grow flex-row justify-center overflow-auto"
  >
    <div
      class="border-s300 aspect-[3/1] h-full overflow-auto border pb-6 pt-5"
      *ngIf="recordsWithValuesLength > 0 && !!eChartInitOpts && !!eChartOptions"
    >
      <m-chart-box
        [eChartInitOpts]="eChartInitOpts"
        [eChartOptions]="eChartOptions"
        [chartInstanceId]="'metrics-chart'"
        style="height: 100%; width: 100%"
      ></m-chart-box>
    </div>

    <div
      *ngIf="dataPoints.length > 0 && recordsWithValuesLength === 0"
      class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
    >
      <div *ngIf="newQueriesLength > 0">Run queries to get data</div>

      <div *ngIf="newQueriesLength === 0 && runningQueriesLength > 0"
        >Queries are running</div
      >

      <div *ngIf="newQueriesLength === 0 && runningQueriesLength === 0"
        >The result has no data</div
      >
    </div>
  </div>
</div>
